import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z"
}), 'ViewCompactSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewCompactSharp.js
// module id = 7093
// module chunks = 2